import React from 'react';
import { Empty } from 'antd';
import { SharedMTIndividualReport } from './templates/SharedMTIndividualReport';
import { resolveMTConfig } from './reportConfigResolver';

export function MTIndividualReport(props) {
   const config = resolveMTConfig(props.template, props.subject_id);

   if (!config) {
      return <Empty description='Report not yet available.' image="../images/brainee_mascot.png" />;
   }

   return <SharedMTIndividualReport {...props} config={config} />;
}
